export const logger: Console = console;
